import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './TextArea.scss';

const TextAreaSimple = ({
  className,
  name,
  onChange,
  placeholder,
  value,
  ...props
}) => (
  <textarea
    className={cx('TextArea', className)}
    id={name}
    name={name}
    onChange={onChange}
    placeholder={placeholder}
    value={value}
    {...props}
  />
);

TextAreaSimple.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

TextAreaSimple.defaultProps = {
  className: undefined,
  name: undefined,
  onChange: () => {},
  placeholder: undefined,
  value: undefined,
};

TextAreaSimple.displayName = 'TextAreaSimple';
export default TextAreaSimple;
